import * as ActionTypes from './CopywriterActionTypes';
import { ICopywriter } from '../Entities';
import CopywriterApi from '../api/copywritersAPI';

function getCopywriterSuccess(result: ICopywriter) {
    return {
        type: ActionTypes.GET_COPYWRITER_SUCCESS,
        result: result
    };
}

export function getCopywriter(id: number) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        CopywriterApi.getCopywriter(id).then((result: ICopywriter) => {
            dispatch(getCopywriterSuccess(result));
            return result;
        });
}

export function createCopywriter(user: ICopywriter) {
    return (dispatch: (result: any) => void, getState: (error: any) => void) =>
        CopywriterApi.createCopywriter(user).then((result: ICopywriter) => {
            dispatch({
                type: ActionTypes.SAVE_COPYWRITER_SUCCESS,
                result: result
            });
        });
}

export function updateCopywriter(user: ICopywriter) {
    // TODO: this is temporary solution that should be removed after the modal will have Firstname and Lastname instead of Firstname and Lastname the Name
    const words = user.name.split(/\s+/);
    if (words.length === 1) {
        user.firstname = words[0];
        user.lastname = '';
    } else if (words.length >= 2) {
        user.firstname = words.slice(0, -1).join(' ');
        user.lastname = words[words.length - 1];
    }

    return (dispatch: (result: any) => void, getState: () => any) =>
        CopywriterApi.updateCopywriter(user).then((returnuser: ICopywriter) => {
            dispatch({
                type: ActionTypes.SAVE_COPYWRITER_SUCCESS,
                result: returnuser
            });
        });
}